import APIBuilder from '@quangphuc/frontend-api-builder/dist';
import Vue from 'vue';
import { AxiosInstance } from 'axios';

export default function BootstrapAPIBuilder(axios: AxiosInstance) {
  APIBuilder.useAxios(axios);
  Vue.prototype.$APIBuilder = APIBuilder;
}
